export const addLeave = '/leaves/draftLeave';
export const getLeaves = '/leaves';
export const updateLeaveStatus = '/leaves/updateStatus/';
export const updateLeave = '/leaves/';
export const getLeaveDetails = '/leaves/';
export const sendLeave = '/leaves/sendLeave';
export const sendToManager = '/leaves/sendToManager/';
export const getUsers = '/user/get-users';
export const addExistingLeave = '/leaves/addExistingLeave';
